import discardFocusedInboxOption from './actions/discardFocusedInboxOption';
import FocusedFull from './components/FocusedFull';
import isFocusedInboxOptionDirty from './utils/isFocusedInboxOptionDirty';
import { isFeatureEnabled } from 'owa-feature-flags';
import { Option, QuickSettingOrder } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import { OwaWorkload } from 'owa-workloads';
import * as React from 'react';
import saveFocusedInboxOption, {
    saveFocusedInboxQuickOption,
} from './actions/saveFocusedInboxOption';

let FocusedInboxOption: Option = {
    key: 'focused',
    titleStringKey: 'optionTitle_focusedInbox',
    searchTermsStringKey: 'optionTitle_focusedInbox',
    fullOptionFormSettings: {
        render: () => <FocusedFull />,
        isDirty: isFocusedInboxOptionDirty,
        onSave: saveFocusedInboxOption,
        onDiscard: discardFocusedInboxOption,
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: () => getUserConfiguration().UserOptions.IsFocusedInboxEnabled,
            onToggle: saveFocusedInboxQuickOption,
        },
        getOrder: () => {
            return isFeatureEnabled('tri-density-controls')
                ? QuickSettingOrder.FocusedDensity
                : QuickSettingOrder.Focused;
        },
        workloads: OwaWorkload.Mail,
        tooltip: {
            tooltipStringKey: 'options_focused_enabled',
        },
    },
    allowedOptionKeys: ['FocusedInbox'],
    isHidden: () => isFeatureEnabled('tri-inbox-plus-v1'),
};

export default FocusedInboxOption;
